export * from './ISHitsPerPage'
export * from './ISPagination'
export * from './ISSortBy'
